import { Spin, Table as BaseTable } from 'antd';

import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/PurchasePlanningSettings/data';
import type { PurchasePlanningSettingsTableType } from '@app/pages/Warehouses/PurchasePlanningSettings/types';

const TABLE = `${PF}_table`;

export const Table: PurchasePlanningSettingsTableType = ({
  isPageLoading = false,
  isFetching = false,
  columns,
  data,
  pagination: { itemsPerPage, page, total },
  range: { from, to },
  onPaginate,
  onPageSizeChange,
}) => {
  const { isMobile } = useWindowSize();

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <BaseTable
          columns={columns}
          dataSource={data}
          rowKey={({ Id }) => Id}
          pagination={
            total > 0
              ? {
                  responsive: true,
                  current: page,
                  total,
                  pageSize: itemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  onShowSizeChange: (_, nextPageSize) =>
                    onPageSizeChange(nextPageSize),
                  showTotal: (itemsTotal) =>
                    isMobile
                      ? `Всего ${itemsTotal}`
                      : `Показаны результаты с ${from} по ${to} из ${itemsTotal}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          loading={isFetching}
          scroll={{ x: 'max-content' }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
